<template>
  <div>
    <vs-row style="padding: 10px">Custom Fields</vs-row>
    <vs-row>
      <vs-col
        v-for="(field, index) in customFields"
        vs-lg="6"
        vs-sm="6"
        vs-xs="6"
        style="padding: 10px"
        :key="index"
      >
        <FieldValue :field="field" />
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import FieldValue from "./FieldValue";

export default {
  name: "Values",
  components: {
    FieldValue,
  },
  computed: {
    customFields() {
      return this.$store.state.customFields.fields;
    },
  }
};
</script>